import { call, put, select } from 'redux-saga/effects';

import { actions as globalActions } from '@elab/core/store/global';
import { actions as authActions } from '@elab/core/store/auth';
import dynaFormsApi from '@elab/core/utils/dynaForms/api';
import dynaForms from '@elab/core/utils/dynaForms';
import { getSearchParam } from '@elab/core/utils/address';
import { actions as uiActions } from '@elab/core/store/ui';

import selectors from './selectors';

const TOKEN_GET_KEY = 'token';
const DEFAULT_REDIRECT_URL = '/resetpassword';

export function* doSubmit(resetPasswordDto, ctx, url) {
    const token = yield call(getSearchParam, TOKEN_GET_KEY);
    resetPasswordDto.token = decodeURIComponent(token || '');
    const successRedirectLink = yield select(selectors.getSuccessRedirectLink);
    const failRedirectLink = yield select(selectors.getFailRedirectLink);
    try {
        const response = yield call(
            dynaFormsApi.doSubmit,
            url || DEFAULT_REDIRECT_URL,
            resetPasswordDto,
        );
        if (response.uid) {
            yield put(
                authActions.doLogin({
                    username: response.uid,
                    password: resetPasswordDto.password,
                    mergeCarts: false,
                    successRedirectLink,
                }),
            );
            yield put(uiActions.setAutoLoginMessage(true));
        } else {
            yield put(globalActions.redirect(successRedirectLink));
        }
    } catch (e) {
        yield put(globalActions.redirect(failRedirectLink));
    }
}

export default storeName => formId => [
    ...dynaForms.createSagaFor(
        storeName,
        dynaFormsApi.getFormMetadata(formId || storeName),
        doSubmit,
        null,
        true,
    ),
];
